import './App.css';
import VideoPlayer from 'react-video-js-player';
import vid1 from './1.mp4'
import vid2 from './2.mp4'
import im1 from './1.png'
import im2 from './2.png'


function GIOMADODONINI(){

  const videoune = vid1;
  const videodeux = vid2;


  return (
    <div className="App-header">


    <div className="premiereerdiv">
     <h1 style={{justifyContent:'flex-start', color:'tomato'}}>
     The Mysterious Lost Work of Giovanni Madonini
        </h1>
<p style={{fontSize:14}}>Giovanni Madonini (1915-1989) Milan, Italy</p>
<p style={{fontSize:16}}>(this NFT is all that remains of the original missing work!)</p>
        <p style={{ textAlign:'center', textAlignLast:'center'}}>
        Being younger in my grandmother's big mansion I was often absorbed by this painting,
        my grandmother told me that she had acquired it a long time ago, one of the paintings abandoned by the French colonists after the independence of Algeria
        besides, my grandmother's mansion also belonged to one of the settlers, surely of high rank given the works he had in his possession
        Signed Giovanni Madonini this Italian artist source of several known works, yet after several years of research this painting remains a real mystery.
        </p>
        <p style={{ textAlign:'center', textAlignLast:'center'}}>
        the survey revealed nothing to us except another and only image found on the internet of a painting in poor condition on a resale site saying that it is an original and that it is located in Morocco nevertheless the quality of their painting remains very mediocre the colors are pale and the whole painting lets say that it is obviously a fake, surely the distance of the two countries allowed the reproduction of the original painting but of course I leave you to compare by yourself,
        </p>
        <p style={{ textAlign:'center', textAlignLast:'center'}}>
        here is the image of the painting in question, judge for yourself:   <a target='_blank' rel="noreferrer" href='https://www.artmajeur.com/fr/alibel0787/artworks/10324654/giovanni-madonini-jpg'>https://www.artmajeur.com/fr/alibel0787/artworks/10324654/giovanni-madonini-jpg</a> <br/>
        on this site they say it was acquired around 1989. except that our painting was acquired (find in the house) many years before that, around the 70s.        </p>
        <p style={{ textAlign:'center', textAlignLast:'center'}}>
        another site using the same image of the first site (we see the wear mark on the painting at the top left, and the same decorates it) explaining what the painting contains: <a target="_blank" rel="noreferrer" href="https://france-estimations.fr/estimation-peinture-pastel-giovanni-madonini/">https://france-estimations.fr/estimation-peinture-pastel-giovanni-madonini/</a> 
        </p>
        <p style={{ textAlign:'center', textAlignLast:'center'}}>
        Of course it is up to you to do your own investigation on the subject, you may still find the same image from the first site (on the amateur art pages) of the painting located in Morocco since it is the only image existing until today on the Internet        </p>


        <div style={{margin:100}}>
      <a href="mailto:listner.bk@gmail.com">Nous Contactez</a>

      </div>
        
    </div>
    {
        //-------------------------------
    }
        <div className="deuxiemmediv">
        <p style={{color: 'orange', fontSize:18}}>(All Images displayed on this site are protected by copyright, thus linked to the property of aquireur, also minted in the form of NFT to avoid any usurpation)</p>
      
       
        <VideoPlayer
        src={videoune}
        width="500"
        height="300"
         />
 <img  src={im1} alt="image1" width="500" height="300"/>
         <VideoPlayer
       src={videodeux}
       width="500"
       height="300"
        />

      
         <img  src={im2} alt="image2" width="500" height="300"/>
       

        </div>
       
        

       
      
      
    </div>


  );


}

export default GIOMADODONINI;